import React from "react";
import FormSubmissionTable, { ColumnHeader } from "../formSubmissionsDataGrid";

const GroupImplementationSurveyFormSubmission: React.FC = () => {
  const columnHeaders: ColumnHeader[] = [
    {
      Column_Name: "Submission ID",
      Field_Name: "Submission_ID",
    },
    {
      Column_Name: "User Email",
      Field_Name: "User_Email",
    },
    {
      Column_Name: "Entry Date",
      Field_Name: "Entry_Date",
    },
  ];

  return (
    <FormSubmissionTable
      columnHeaders={columnHeaders}
      formId={7}
      formName={"Group Implementation Survey"}
    ></FormSubmissionTable>
  );
};

export default GroupImplementationSurveyFormSubmission;
